import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
export const Contact = () => {
  return <div className="py-20 lg:py-24 bg-gray50 min-h-[calc(100vh-300px)]" data-id="element-476">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-477">
        <div className="max-w-3xl mx-auto text-center mb-14" data-id="element-478">
          <span className="text-sm font-bold uppercase tracking-wider text-brandRed" data-id="element-479">
            Get in Touch
          </span>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mt-3 mb-5 leading-tight" data-id="element-480">
            Contact Us
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-481">
            Have questions about wholesale access, private-label production, or
            custom uniform orders? Our team is here to help.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-482">
          <div className="bg-white p-8 rounded-xl border border-gray200 shadow-sm text-center flex flex-col items-center" data-id="element-483">
            <div className="w-14 h-14 rounded-full bg-brandRed/10 flex items-center justify-center mb-6" data-id="element-484">
              <Phone className="w-6 h-6 text-brandRed" data-id="element-485" />
            </div>
            <h3 className="text-xl font-bold text-ink mb-2" data-id="element-486">Phone</h3>
            <p className="text-gray-600 mb-4" data-id="element-487">Mon-Fri from 9am to 10pm EST</p>
            <a href="tel:8886998511" className="text-brandRed font-bold hover:text-brandRedDark transition-colors" data-id="element-488">
              (888) 699-8511
            </a>
          </div>

          <div className="bg-white p-8 rounded-xl border border-gray200 shadow-sm text-center flex flex-col items-center" data-id="element-489">
            <div className="w-14 h-14 rounded-full bg-brandRed/10 flex items-center justify-center mb-6" data-id="element-490">
              <Mail className="w-6 h-6 text-brandRed" data-id="element-491" />
            </div>
            <h3 className="text-xl font-bold text-ink mb-2" data-id="element-492">Email</h3>
            <p className="text-gray-600 mb-4" data-id="element-493">We'll respond within 24 hours</p>
            <a href="mailto:info@customuniformsupplier.com" className="text-brandRed font-bold hover:text-brandRedDark transition-colors" data-id="element-494">
              info@customuniformsupplier.com
            </a>
          </div>

          <div className="bg-white p-8 rounded-xl border border-gray200 shadow-sm text-center flex flex-col items-center" data-id="element-495">
            <div className="w-14 h-14 rounded-full bg-brandRed/10 flex items-center justify-center mb-6" data-id="element-496">
              <MapPin className="w-6 h-6 text-brandRed" data-id="element-497" />
            </div>
            <h3 className="text-xl font-bold text-ink mb-2" data-id="element-498">Office</h3>
            <p className="text-gray-600 mb-4" data-id="element-499">Corporate Headquarters</p>
            <span className="text-charcoal font-medium" data-id="element-500">New York, NY</span>
          </div>
        </div>
      </div>
    </div>;
};